import { render, staticRenderFns } from "./Airticketgaiqian.vue?vue&type=template&id=40f9f07f&scoped=true"
import script from "./Airticketgaiqian.vue?vue&type=script&lang=js"
export * from "./Airticketgaiqian.vue?vue&type=script&lang=js"
import style0 from "./Airticketgaiqian.vue?vue&type=style&index=0&id=40f9f07f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40f9f07f",
  null
  
)

export default component.exports